module.exports = __webpack_public_path__ + "static/vincent-harris-e389d1f2a95fe125e89e1ca09cec21c9.jpg";